module.exports = __webpack_public_path__ + "static/img/account.7f199cfa.svg";